<template>
  <span v-if="!date">
    -
  </span>

  <v-tooltip
    v-else
    top
  >
    <template #activator="{ on }">
      <span v-on="on">
        {{ dateWithUTCShift }}
      </span>
    </template>

    <v-layout column>
      <v-layout>
        <strong class="mr-1">
          Original Date:
        </strong>
        {{ originalDate }}
      </v-layout>

      <v-layout>
        <strong class="mr-1">
          Local Date:
        </strong>
        {{ localDate }}
      </v-layout>
    </v-layout>
  </v-tooltip>
</template>

<script>
import { mapGetters } from 'vuex';

import { formatDisplayDate } from '@helpers';

import { APP_SETTINGS_NAMESPACE } from '@store';

export default {
  name: 'PbDateTime',

  props: {
    date: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd, hh:mm a',
    },
  },

  computed: {
    ...mapGetters(APP_SETTINGS_NAMESPACE, ['timeZoneUTCShift']),

    dateWithUTCShift() {
      return `${
        formatDisplayDate(`${this.date}`, {
          UTCShift: this.timeZoneUTCShift,
          dateFormat: this.format,
        })
      } UTC${this.timeZoneUTCShift < 0 ? this.timeZoneUTCShift : `+${this.timeZoneUTCShift}`}`;
    },

    originalDate() {
      return `${formatDisplayDate(this.date, {
        dateFormat: this.format,
        type: 'server',
      })} UTC+0`;
    },

    localDate() {
      return `${formatDisplayDate(this.date, {
        dateFormat: this.format.toLowerCase().endsWith('z') ? this.format : `${this.format} z`,
      })}`.replace('GMT', 'UTC');
    },
  },
};
</script>
